module.exports = __webpack_public_path__ + "img/city_newtaipei2.be325b9d.png";